import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image.png'


const _withScopeId = n => (_pushScopeId("data-v-54715eba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "rectification-detail"
}
const _hoisted_2 = { class: "state" }
const _hoisted_3 = {
  class: "content",
  style: {"margin-bottom":"8px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "基本信息", -1))
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "整改单号：", -1))
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "关联检查：", -1))
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "检查人：", -1))
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开始时间：", -1))
const _hoisted_13 = { class: "item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "完成期限：", -1))
const _hoisted_15 = {
  class: "content",
  style: {"margin-bottom":"8px"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "任务信息", -1))
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "任务名称：", -1))
const _hoisted_19 = { class: "item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "检查项目：", -1))
const _hoisted_21 = { class: "item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "检查内容：", -1))
const _hoisted_23 = { class: "value" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"background-color":"#F8542C","color":"#fff","display":"inline-block","padding":"2px 4px","border-radius":"2px","margin-left":"auto"} }, "不合格", -1))
const _hoisted_25 = { class: "item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "存在问题：", -1))
const _hoisted_27 = { class: "item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "问题照片：", -1))
const _hoisted_29 = { class: "image" }
const _hoisted_30 = ["src", "onClick"]
const _hoisted_31 = { class: "item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "备注：", -1))
const _hoisted_33 = {
  key: 0,
  class: "content",
  style: {"margin-bottom":"8px"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "整改信息", -1))
const _hoisted_35 = { class: "item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "整改说明：", -1))
const _hoisted_37 = { class: "item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "整改照片：", -1))
const _hoisted_39 = { class: "image" }
const _hoisted_40 = ["src", "onClick"]
const _hoisted_41 = {
  key: 1,
  class: "form",
  style: {"margin-bottom":"20px"}
}
const _hoisted_42 = {
  class: "item",
  style: {"border-bottom":"1px solid #CCD3DF"}
}
const _hoisted_43 = { class: "title" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("整改说明"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#F8542C"} }, "*")
], -1))
const _hoisted_45 = { class: "item" }
const _hoisted_46 = { class: "title" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "整改照片", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "uf-idcard-uploader__btn",
  alt: ""
}, null, -1))
const _hoisted_49 = {
  key: 2,
  class: "footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_ctx.detail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, "当前状态：" + _toDisplayString(_ctx.detail.state_name), 1),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(_toDisplayString(_ctx.detail.orderid || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(_toDisplayString(_ctx.detail.pool_orderid || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(_toDisplayString(_ctx.detail.handler_user_info?.name || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createTextVNode(_toDisplayString(_ctx.detail.create_time_name || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createTextVNode(_toDisplayString(_ctx.detail.reform_over_time_name || "-"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createTextVNode(_toDisplayString(_ctx.detail.pool_name || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createTextVNode(_toDisplayString(_ctx.detail.item_name || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("span", _hoisted_23, [
              _createTextVNode(_toDisplayString(_ctx.detail.norm_title || "-") + " ", 1),
              _hoisted_24
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createTextVNode(_toDisplayString(_ctx.detail.problem || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("span", _hoisted_29, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.pic_arr, (img, index) => {
                return (_openBlock(), _createElementBlock("img", {
                  src: img.photo_thumb_file,
                  onClick: ($event: any) => (_ctx.clickImage(index, _ctx.detail.pic_arr)),
                  key: img.id
                }, null, 8, _hoisted_30))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createTextVNode(_toDisplayString(_ctx.detail.desc || "-"), 1)
          ])
        ]),
        (_ctx.detail.state !== '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createTextVNode(_toDisplayString(_ctx.detail.reform_desc || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("span", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.reform_pic_arr, (img, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      src: img.photo_thumb_file,
                      onClick: ($event: any) => (_ctx.clickImage(index, _ctx.detail.reform_pic_arr)),
                      key: img.id
                    }, null, 8, _hoisted_40))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("span", null, _toDisplayString(_ctx.reform_desc.length) + "/200", 1)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_van_field, {
                    modelValue: _ctx.reform_desc,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reform_desc) = $event)),
                    rows: "3",
                    autosize: "",
                    type: "textarea",
                    maxlength: "200",
                    placeholder: "请输入留言"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("span", null, _toDisplayString(_ctx.fileList.length) + "/4", 1)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_van_uploader, {
                    modelValue: _ctx.fileList,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList) = $event)),
                    "max-count": 4,
                    accept: "image/*,video/*",
                    class: "uf-idcard-uploader",
                    "image-fit": "contain",
                    "after-read": _ctx.upload
                  }, {
                    default: _withCtx(() => [
                      _hoisted_48
                    ]),
                    _: 1
                  }, 8, ["modelValue", "after-read"])
                ])
              ])
            ])),
        (_ctx.detail.state == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _createVNode(_component_van_button, {
                type: "primary",
                block: "",
                color: "#3d6eeb",
                onClick: _ctx.handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("提交整改单")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}